<template>
  <b-modal
    body-class="create-project-modal-body"
    footer-class="create-project-modal-footer"
    header-class="create-project-modal-header"
    id="new-project"
    centered
    @hide="resetForm"
    @show="updateForm"
  >
    <template #modal-header="{}">
      <subtitle>{{ title }}</subtitle>
      <button class="news-close-button" @click="closeModal" />
    </template>

    <form>
      <custom-input
        required
        inputType="text"
        placeholder="Наименование"
        labelText="Наименование"
        v-model="formData.name"
        :errorMessage="validationErrors['name']"
        @keydown.enter.prevent="handleSaveButtonClick"
        :inputValue="formData.name"
      />

      <main-select
        class="create-form-item"
        label="Город"
        id="create-city"
        v-model="formData.city"
        :options="cityOptions"
        placeholder="Выберите город"
        :clearable="false"
        isRequired
        :errorMessage="validationErrors['city']"
      />

      <custom-input
        class="create-form-input"
        inputType="text"
        placeholder="Например: ул. Ленина, 5"
        labelText="Адрес объекта"
        v-model="formData.address"
        :errorMessage="validationErrors['address']"
        @keydown.enter.prevent="handleSaveButtonClick"
        :inputValue="formData.address"
      />

      <custom-input
        required
        class="create-form-input"
        inputType="number"
        labelText="Атмосферное давление, кПа"
        v-model="formData.P0"
        :inputValue="formData.P0"
        :errorMessage="validationErrors['P0']"
        @keydown.enter.prevent="handleSaveButtonClick"
      />

      <main-select
        class="create-form-item"
        label="Загроможденность окружающего пространства"
        id="create-blocking-up-class"
        v-model="formData.blockingUpClass"
        :options="blockingUpSelectOptions"
        placeholder="Выберите город"
        :clearable="false"
        isRequired
        tooltipValue="<p align='left'><b>Класс 1</b> - наличие длинных труб, полостей, каверн, заполненных горючей смесью, при сгорании которой возможно ожидать формирование турбулентных струй продуктов сгорания, имеющих размеры не менее трех размеров детонационной ячейки данной смеси.<p>
        <p align='left'><b>Класс 2</b> - сильно загроможденное пространство: наличие полузамкнутых объемов высокая плотность размещения технологического оборудования, лес, большое количество повторяющихся препятствий.<p>
        <p align='left'><b>Класс 3</b> - средне загроможденное пространство: отдельно стоящие технологические установки, резервуарный парк.<p>
        <p align='left'><b>Класс 4</b> - слабо загроможденное и свободное пространство.<p>"
        :errorMessage="validationErrors['blockingUpClass']"
      />
    </form>

    <template #modal-footer="{}">
      <main-button :loading="loading" class="create-project-footer-button" @click="handleSaveButtonClick">
        Сохранить
      </main-button>
      <main-button class="create-project-footer-button" color="link" @click="closeModal">Отмена</main-button>
    </template>
  </b-modal>
</template>

<script>
import Subtitle from "../ui/Subtitle.vue";
import Input from "../ui/Input.vue";
import MainSelect from "../ui/MainSelect.vue";
import MainButton from "../ui/MainButton.vue";
import { DEFAULT_CREATE_PROJECT_FORM_DATA } from "../../constants/constants";

export default {
  components: {
    Subtitle,
    "custom-input": Input,
    MainSelect,
    MainButton,
  },
  props: {
    project: Object,
    isNewRecord: Boolean,
    title: String,
  },
  data() {
    return {
      formData: {
        name: "",
        city: "",
        address: "",
        P0: 101.3,
        blockingUpClass: { code: "4", label: "Класс 4" },
      },
      cityOptions: [{}],
      blockingUpSelectOptions: [
        { code: "1", label: "Класс 1" },
        { code: "2", label: "Класс 2" },
        { code: "3", label: "Класс 3" },
        { code: "4", label: "Класс 4" },
      ],
      schema: {},
      requiredFields: ["name", "city", "P0", "blockingUpClass"],
      validationErrors: {},
      isFormValid: true,
      loading: false,
      defaultFormValues: DEFAULT_CREATE_PROJECT_FORM_DATA,
    };
  },

  methods: {
    handleSaveButtonClick() {
      if (this.project && this.project.id) {
        this.update();
        return;
      }
      this.create();
    },

    create() {
      this.validate();
      if (!this.isFormValid) return;

      this.loading = true;
      this.$http
        .post("projects/create", {
          name: this.formData.name,
          address: this.formData.address,
          P0: this.formData.P0,
          blocking_up_class: this.formData.blockingUpClass.code,
          city: this.formData.city.code,
        })
        .then((response) => {
          this.$emit("create", response.data);
        })
        .catch((e) => {
          console.error(e.response.data);
          if (e.response.data) {
            this.validationErrors = e.response.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    validate() {
      this.validationErrors = {};
      this.requiredFields.forEach((field) => {
        if (!this.formData[field]) {
          this.validationErrors[field] = "Необходимо заполнить поле";
        }
      });
      if (Object.keys(this.validationErrors).length) {
        this.isFormValid = false;
      } else {
        this.isFormValid = true;
      }
    },

    update() {
      this.validate();
      if (!this.isFormValid) return;

      this.loading = true;
      this.$http
        .post("projects/update?id=" + this.project.id, {
          name: this.formData.name,
          address: this.formData.address,
          P0: this.formData.P0,
          blocking_up_class: this.formData.blockingUpClass.code,
          city: this.formData.city.code,
        })
        .then((response) => {
          this.$emit("update:project", response.data);
          this.$emit("clearCalculations");
          this.$bvModal.hide("new-project");
        })
        .catch((e) => {
          console.error(e.response.data);
          if (e.response.data) {
            this.validationErrors = e.response.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetForm() {
      this.formData = Object.assign({}, this.defaultFormValues);
      this.$emit("onResetProject");
    },

    closeModal() {
      this.$bvModal.hide("new-project");
    },

    updateForm() {
      if (this.project && this.project.id) {
        const { city, P0, address, name, blocking_up_class } = this.project;
        const currentCity = this.cityOptions.find((item) => Number(item.code) === Number(city));

        this.formData.P0 = P0;
        this.formData.city = currentCity;
        this.formData.address = address;
        this.formData.name = name;
        this.formData.blockingUpClass = { code: blocking_up_class, label: `Класс ${blocking_up_class}` };
      }
    },
  },

  watch: {
    project() {
      this.updateForm();
    },
  },

  mounted() {
    this.$http
      .get("risk/cities/list")
      .then((response) => {
        this.cityOptions = response.data.map((city) => {
          return { label: city.CITY, code: city.ID };
        });
        if (this.project && this.project.city && !this.formData.city) {
          this.formData.city = this.cityOptions.find((item) => Number(item.code) === Number(this.project.city));
        }
      })
      .catch((e) => {
        alert(`Ошибка: ${e}`);
      });
  },
};
</script>

<style>
.create-project-modal-header {
  padding: 24px 24px 0;
  border: 0;
}

.create-project-modal-body {
  padding: 32px 24px 0;
}

.create-project-modal-footer {
  margin-top: 32px;
  padding: 16px 24px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: var(--background-color);
}

.create-form-item {
  margin-top: 16px;
}

.create-form-input {
  margin-top: 16px;
}

.create-project-footer-button {
  margin: 0 16px 0 0;
}
</style>
